import scrollToElement from "../helpers/scrollToElement";
import accessibility from '../helpers/accessibility';
import { isMobile } from '../helpers/device.js';
export const hasQuantityError = () => {
  const quantityError = document.getElementById('productQuantityError');
  return !!quantityError;
}

export const getQuantityErrorMessage = () => {
  if (hasQuantityError()) {
    const quantityError = document.getElementById('productQuantityError');
    return quantityError.innerText;
  }
  return null;
};

export const scrollIfQuantityError = () => {
  if (hasQuantityError()) {
    const verticalOffset = isMobile ? -120 : -70;
    const quantityError = document.getElementById('productQuantityError');
    scrollToElement(quantityError, verticalOffset);
    accessibility.alert(quantityError, 100);
    quantityError.focus();
  }
}
